module.exports = __webpack_public_path__ + "media/ppc/scholarships-for-all-2a3418f1.png";